import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CellDoubleClickedEvent, GridOptions } from 'ag-grid';
import { AditionalPayorService } from '../../services/aditional-payor.service';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-add-payor-express',
  templateUrl: './add-payor-express.component.html',
  styleUrls: ['./add-payor-express.component.scss']
})
export class AddPayorExpressComponent implements OnInit, OnChanges {

  @Input() riderId?: number;

  gridOptions: GridOptions;
  form: FormGroup;
  aditionalPayor: any[];

  constructor(
    private fb: FormBuilder,
    private aditionalPayorService: AditionalPayorService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    this.aditionalPayor = [];
    this.initGrid();
    this.createForm();
  }

  ngOnInit() {
    this.setRiderId();
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['riderId']) {
      this.setRiderId();
    }
  }

  initGrid() {
    this.gridOptions = <GridOptions>{
      enableColResize: true,
      enableFilter: true,
      enableSorting: true,
      columnDefs: [
        {
          headerName: 'Payor',
          field: 'description',
          width: 300
        },
        {
          headerName: 'Policy',
          field: 'memberid',
          width: 220
        },
        {
          headerName: 'Description',
          field: 'note',
          width: 300
        },
      ],
      onGridReady: () => {
        this.getData();
        this.gridOptions.api.sizeColumnsToFit();
      },
      onCellDoubleClicked: (params: CellDoubleClickedEvent) => {
        if (params) {
          this.form.setValue(params.data);
        }
      }
    };
  }

  createForm() {
    this.form = this.fb.group({
      additionalpayorid: undefined,
      riderid: ['', Validators.required],
      description: ['', Validators.required],
      memberid: ['', Validators.required],
      note: ['', Validators.required],
      modifiedon: '',
      addedon: ''
    });
  }

  getData() {
    this.aditionalPayorService.get(this.riderId).subscribe((resp: any) => {
      this.aditionalPayor = resp;
      this.gridOptions.api.setRowData(resp);
    }, error => this.sweetAlertHelper.captureException(error));
  }

  onAdd() {
    if (this.form.controls['additionalpayorid'].value) {
      this.update();
      return;
    }
    this.save();
  }

  save() {
    this.aditionalPayorService.post(this.form.value).subscribe((resp: any) => {
      if (resp) {
        this.sweetAlertHelper.createCustomAlert({ title: 'success', text: resp.message, type: 'success' })
          .then(() => {
            this.aditionalPayor.push(this.form.value);
            this.afterService();
          });
      }
    }, (error: any) => {
      this.sweetAlertHelper.captureException(error);
    });
  }

  update() {
    this.aditionalPayorService.put(this.form.value).subscribe((resp: any) => {
      if (resp) {
        this.sweetAlertHelper.createCustomAlert({ title: 'success', text: resp.message, type: 'success' })
          .then(() => {
            this.aditionalPayor.push(this.form.value);
            this.afterService();
          });
      }
    }, (error: any) => {
      this.sweetAlertHelper.captureException(error);
    });
  }

  setRiderId() {
    this.form.controls['riderid'].setValue(this.riderId);
  }

  onCancel() {
    this.form.reset();
    this.setRiderId();
  }

  onDelete() {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.aditionalPayorService.delete(this.form.controls['additionalpayorid'].value).subscribe((resp: any) => {
          if (resp) {
            this.sweetAlertHelper.createCustomAlert({ title: 'success', text: resp.message, type: 'success' })
              .then(() => {
                this.afterService();
              });
          }
        }, (error) => this.sweetAlertHelper.captureException(error));
      }
    });
  }

  afterService() {
    this.getData();
    this.form.reset();
    this.setRiderId();
  }

  get disabledBtns(): boolean {
    return !this.form.controls['additionalpayorid'].value;
  }

  get actionBtn(): string {
    return this.form.controls['additionalpayorid'].value ? 'Update' : 'Add';
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/add-payor-express/add-payor-express.component.ts